import styled from 'styled-components';

export const RegisteredSeasonsStyled = styled.div`
  padding-bottom: calc(var(--apx) * 20);

  .paper {
    .grid-item {
      text-transform: uppercase;

      &:nth-of-type(1) {
        font-family: 'DINNextLTPro-Heavy';
        font-size: calc(var(--apx) * 18);
        color: var(--dark);
        line-height: 1.6;
      }

      &:nth-of-type(2) {
        font-size: calc(var(--apx) * 14);
        @mixin h6-desktop;
        line-height: 1.8;
      }

      &:nth-of-type(3) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: calc(var(--apx) * 18);
        @mixin h5-desktop;
      }
    }
  }
`;
